import { getPaymentMethods } from './http'
import { eligiblePaymentMethods, initialPaymentMethod } from './payment-methods'

export default {
  data() {
    return { paymentCatalog: { methods: [], additionalMethods: {} }, paymentMethodsLoading: true, paymentMethodsError: false }
  },
  computed: {
    providerMethods() {
      return eligiblePaymentMethods(this.paymentCatalog, this.paymentEligibility)
    },
  },
  async created() {
    this.selectPaymentMethod(null)
    try {
      this.paymentCatalog = await getPaymentMethods()
      this.selectPaymentMethod(initialPaymentMethod(this.providerMethods))
    } catch (error) {
      this.paymentMethodsError = true
    } finally {
      this.paymentMethodsLoading = false
    }
  },
  methods: {
    paymentTitle(option) {
      if (option.method === 'KeksPay') return 'KEKS Pay'
      if (option.method === 'PayCek') return 'PayCek'

      return option.method === 'CreditCard' ? `${this.$t('cardPayment')} – ${option.label}` : option.label
    },
    paymentDescription(option) {
      if (option.method === 'CreditCard') return this.$t('onlinePaymentProvider', { provider: option.label })

      if (option.method === 'KeksPay') return this.$t('keksPayDesc')
      if (option.method === 'PayCek') return this.$t('cryptoPayment')

      return this.$t('onlinePaymentProvider', { provider: option.label })
    },
    paymentLogo(option) {
      return { CreditCard: '/assets/all-cards.svg', KeksPay: '/assets/Keks_pay.svg', PayCek: '/assets/paycek-logo.svg' }[option.method]
    },
  },
}
